/**
 * Arabic Home Translations
 * 首页翻译模块 - 阿拉伯语
 * 
 * SEO 关键词覆盖：
 * - سخان بالأشعة تحت الحمراء / مصنع / الجملة
 * - تدفئة إشعاعية / موفر للطاقة
 * - سخان شرفة / مطعم / ورشة
 */

import type { HomeTranslations } from '../../types';

export const arHome: HomeTranslations = {
  hero: {
    future: 'مستقبل التدفئة',
    title: 'فعال وصديق للبيئة',
    subtitle: 'التدفئة بالأشعة تحت الحمراء',
    description: 'انقل دفء الشمس إلى المساحات الخارجية. توفر تقنيتنا المتقدمة بالأشعة تحت الحمراء البعيدة حرارة إشعاعية فورية وهادئة وموفرة للطاقة لشرفات المطاعم والحدائق والورش ومناطق المسابح.',
    cta: 'استكشف المنتجات',
    watchVideo: 'شاهد الفيديو',
    trusted: 'موثوق به من قبل أكثر من 5000 عميل',
    worldwide: 'توزيع عالمي',
    slides: {
      "slide5": {
        "title": "معرض كانتون",
        "subtitle": "نلتقي في قوانغتشو",
        "description": "التقوا بفريق JH Heatsup في معرض كانتون. اكتشفوا حلول التدفئة لدينا وناقشوا فرص التعاون.",
        "exhibition": {
          "eyebrow": "JH HEATSUP · معرض كانتون",
          "date": "15–19 أكتوبر 2026",
          "venue": "مجمع معرض كانتون، قوانغتشو",
          "boothLabel": "زوروا جناحنا",
          "booth": "القاعة 3.2 · الجناح L16"
        }
      },
      "slide4": {
        "title": "جلوبال سورسز",
        "subtitle": "الإلكترونيات الاستهلاكية",
        "description": "التقوا بفريق JH Heatsup في هونغ كونغ. اكتشفوا حلول التدفئة لدينا وناقشوا فرص التعاون.",
        "exhibition": {
          "eyebrow": "JH HEATSUP · معرض هونغ كونغ",
          "date": "11–14 أكتوبر 2026",
          "venue": "آسيا وورلد إكسبو، هونغ كونغ",
          "boothLabel": "زوروا جناحنا"
        }
      },
      slide1: {
        title: 'فعال وصديق للبيئة',
        subtitle: 'التدفئة بالأشعة تحت الحمراء',
        description: 'انقل دفء الشمس إلى المساحات الخارجية. توفر تقنيتنا المتقدمة بالأشعة تحت الحمراء البعيدة حرارة إشعاعية فورية وهادئة وموفرة للطاقة لشرفات المطاعم والحدائق والورش ومناطق المسابح.',
      },
      slide2: {
        title: 'آمن وموثوق',
        subtitle: 'مصمم للاستخدام اليومي',
        description: 'مصممة بمعيار IPX4 للمقاومة المائية وحماية مدمجة من الحرارة الزائدة ومواد متينة. توفر سخاناتنا بالأشعة تحت الحمراء دفءًا مستقرًا وموثوقًا يومًا بعد يوم — آمنة للتشغيل طوال الليل.',
      },
      slide3: {
        title: 'هادئ للغاية',
        subtitle: 'دفء مريح',
        description: 'استمتع بدفء إشعاعي صامت ومن دون وهج يشعر بالطبيعية، بدون تجفيف للهواء أو تدوير الغبار. تدفئة صحية بالأشعة تحت الحمراء للمنازل والمكاتب.',
      },
    },
  },
  about: {
    title: 'عن JH للتدفئة',
    subtitle: 'رائدون في تقنية الأشعة تحت الحمراء منذ عام 2006',
    intro1: 'شركة فوجيان جينغهو للتكنولوجيا البيئية (JH Heatsup) هي مصنع سخانات بالأشعة تحت الحمراء رائد في الصين، متخصص في سخانات الأشعة تحت الحمراء البعيدة الإشعاعية الموفرة للطاقة للاستخدام السكني والتجاري.',
    intro2: 'نركز على البحث والتطوير والتصنيع بنظام OEM/ODM والتوزيع العالمي لتوفير سخانات بالأشعة تحت حمراء عالية الجودة لمشتري الجملة حول العالم. تحمل منتجاتنا شهادات CE و CB و SAA و RoHS، ويتم تصديرها إلى أكثر من 80 دولة عبر أوروبا وأستراليا والشرق الأوسط وجنوب شرق آسيا.',
    stats: {
      yearsExperience: 'سنوات الخبرة',
      countriesExported: 'البلدان المصدرة',
      patents: 'براءات الاختراع',
      satisfaction: 'الرضا',
    },
    ceoQuote: '"نحن ملتزمون بخلق عالم أكثر خضرة ودفئًا من خلال التكنولوجيا."',
    ceoLabel: '- رسالة الرئيس التنفيذي',
    factoryAlt: 'خط إنتاج مصنع سخانات JH بالأشعة تحت الحمراء',
  },
  features: {
    title: 'لماذا تختار سخانات JH بالأشعة تحت الحمراء',
    subtitle: 'تقنيتنا بالأشعة تحت الحمراء البعيدة تحاكي مبدأ التدفئة الطبيعي للشمس، وتدفئ الأشياء والأشخاص مباشرة وليس الهواء فقط. مما يجعل سخانات الأشعة تحت الحمراء أكثر كفاءة في الطاقة بنسبة تصل إلى 80٪ مقارنة بأجهزة التدفئة التقليدية بالحمل الحراري.',
    energy: {
      title: 'موفر للطاقة',
      desc: 'كفاءة تحويل حراري تصل إلى 99٪ — سخانات الأشعة تحت الحمراء الإشعاعية تستهلك حتى 80٪ كهرباء أقل من أجهزة التدفئة التقليدية',
    },
    quiet: {
      title: 'هادئ للغاية',
      desc: 'تصميم بدون مروحة بالأشعة تحت الحمراء بدون ضوء أو ضوضاء أو تدوير غبار',
    },
    safe: {
      title: 'آمن وموثوق',
      desc: 'سخانات بالأشعة تحت الحمراء مقاومة للماء بمعيار IPX4 مع حماية مدمجة من الحرارة الزائدة، آمنة للاستخدام الداخلي والخارجي',
    },
    smart: {
      title: 'تحكم ذكي',
      desc: 'تحكم عبر تطبيق WiFi Tuya لجدولة درجة الحرارة عن بُعد — وفر الطاقة من هاتفك',
    },
  },
  categoriesSection: {
    title: 'تسوّق حسب الفئة',
    subtitle: "استكشف سخانات الأشعة تحت الحمراء والسخانات المحمولة وسخانات الغاز للعثور على الحل المناسب لمساحتك، من الأفنية الخارجية إلى غرف المعيشة.",
    viewAll: 'عرض جميع المنتجات',
    cards: {
      infrared: {
        badge: 'شائع',
        tagline: 'سخانات إشعاعية بالأشعة تحت الحمراء البعيدة لدفء فعّال ومركّز',
        description: 'مثالي لشرفات المطاعم والورش والمستودعات والتدفئة الداخلية المثبتة على الحائط.',
        cta: 'تسوّق الآن',
      },
      portable: {
        tagline: 'سخانات ألياف كربون وهالوجين محمولة لدفء مرن',
        description: 'رائع للمنازل والمكاتب والتدفئة تحت المكتب ومناطق الترفيه الخارجية.',
        cta: 'تسوّق الآن',
      },
      gas: {
        tagline: "سخانات غاز وطاولات نار لدفء في الهواء الطلق",
        description: "أنشئ مساحة خارجية دافئة ومريحة لشرفات المطاعم والحدائق والتجمعات في الفناء.",
        cta: "تسوّق الآن",
      },
    },
  },
  ctaSection: {
    title: 'هل أنت مستعد لترقية نظام التدفئة الخاص بك؟',
    subtitle: 'تواصل مع JH Heatsup اليوم للحصول على أسعار الجملة وخدمات OEM/ODM واستشارة مجانية.',
    cta: 'احصل على عرض سعر',
  },
};
